import {
  PaymentMethod,
  RenewalBaseFragment,
  RenewalStatus,
  RenewalWithCheckReceivalFragment,
} from "@covertree/agent-portal-graphql";
import { useAccessPattern } from "@hooks/useAccessPattern";
import { useCallback, useMemo } from "react";

export function useCheckReceivalPermissions(
  renewal?: RenewalWithCheckReceivalFragment | RenewalBaseFragment
) {
  const { canMarkRenewalAsPaid: canMarkRenewalAsPaidPermission } =
    useAccessPattern();

  const isRenewalMarkable = useCallback(
    (renewal: RenewalWithCheckReceivalFragment | RenewalBaseFragment) =>
      canMarkRenewalAsPaidPermission &&
      renewal &&
      ![
        RenewalStatus.Discarded,
        RenewalStatus.Issued,
        RenewalStatus.NonRenewalIssued,
      ].includes(renewal.status) &&
      renewal.paymentMethod === PaymentMethod.MortgageBill,
    [renewal, canMarkRenewalAsPaidPermission]
  );

  const canMarkRenewalAsPaid = useMemo(
    () =>
      isRenewalMarkable(renewal) &&
      !(renewal as RenewalWithCheckReceivalFragment)?.checkReceival,
    [renewal]
  );

  const canMarkRenewalAsUnpaid = useMemo(
    () =>
      isRenewalMarkable(renewal) &&
      !!(renewal as RenewalWithCheckReceivalFragment)?.checkReceival,
    [renewal]
  );

  return {
    canMarkRenewalAsPaid,
    canMarkRenewalAsUnpaid,
    isRenewalMarkable,
  };
}
